module.exports = __webpack_public_path__ + "static/img/footer-code1.5ef73f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-code1.jpg
// module id = ehpm
// module chunks = 22